// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__COrio","wrapper":"FAQ_wrapper__HVWZ5","title":"FAQ_title__j0yki","header":"FAQ_header__s4QLr","header__title":"FAQ_header__title__+7kxx","text":"FAQ_text__FkukJ"};